import manAndHorse from '@/assets/images/man-horse.webp';
import manGrayHorse from '@/assets/images/man-gray-horse.webp';
import girlAndHorse from '@/assets/images/collected.webp';
import manLeadsHorse from '@/assets/images/man-leads-horse.webp';

export const HIPPOTHERAPY_SWIPED_IMAGES = [manAndHorse, manGrayHorse, girlAndHorse, manLeadsHorse];
